// flow
import React from 'react';
import IntroText from 'Components/IntroText';
import { slugify } from 'Utils';
import DefaultPage from 'Containers/DefaultPage';
import { Container, Row, Col } from 'Components/Grid';
import JobListItem from 'Components/JobListItem';
import Lacon from 'Components/Lacon';
import JobModel from 'Stores/JobModel';
import DealerModel from 'Stores/DealerModel';
import styles from './styles.scss';
import { getGivenBackground } from 'Utils/getColor/index';

type Props = {
  dealer: DealerModel,
  jobs: Array<Object>,
  deeplinkId?: number,
};

export default class CareerJobList extends React.Component<Props> {
  static defaultProps = {
    jobs: [],
  };

  renderJobItem(job) {
    return (
      <JobListItem
        key={`job-item-${job.id}`}
        title={job.title}
        introtext={job.description}
        date={job.getAvailabilityLabel()}
        category={job.getLabel('departments', job.department)}
        ctaHref={`/ueber-uns/autohaus/karriere/${job.id}-${slugify(job.title)}/`}
      />
    );
  }

  renderJobList(jobs) {
    if (!jobs.length) {
      return (
        <IntroText
          title="Zurzeit ist unser Team komplett"
          background={getGivenBackground('grey')}
        />
      );
    }

    return (
      <Container>
        <div className={styles.jobItems}>
          {jobs.map(job => this.renderJobItem(new JobModel(job)))}
        </div>
      </Container>
    );
  }

  render() {
    const { dealer, jobs, deeplinkId } = this.props;
    const { career } = dealer.settings;

    // use defaults from dealer model when no custom props are set
    const phone = career.contactPhone || dealer.mainContact.phone;
    const email = career.contactEmail || dealer.mainContact.email;

    return (
      <DefaultPage background={getGivenBackground('white')} deeplinkId={deeplinkId}>
        {this.renderJobList(jobs)}
        <Container>
          <div className={styles.footer}>
            <Row>
              <Col cols={12} m={6} l={7}>
                <Lacon label="Schicken Sie uns Ihre Initiativbewerbung">
                  Wir sind immer auf der Suche nach guten Mitarbeitern. Schicken Sie uns Ihre
                  Initiativbewerbung und wir melden uns bei Ihnen, sobald eine geeignete Stelle für
                  Sie offen ist.
                </Lacon>
              </Col>
              <Col className={styles.hideltL} l={1} />
              <Col cols={12} m={6} l={4}>
                <Lacon label="E-Mail">
                  <a href={`mailto: ${email}`}>{email}</a>
                </Lacon>
                <Lacon label="Telefon">
                  <a href={`tel: ${phone}`}>{phone}</a>
                </Lacon>
              </Col>
            </Row>
          </div>
        </Container>
      </DefaultPage>
    );
  }
}
